export default __webpack_public_path__ + "static/media/hdb-flats-circle.b6131125.svg";